// extracted by mini-css-extract-plugin
module.exports = {"time":"PlayHeadPosition_time__3nZdj"};